(function () {
    'use strict';

    var controllerId = 'shell_CND';
    angular.module('app').controller(controllerId,['$rootScope', 'common', 'config', 'datacontext', 'sectionMenu', shell_CND]);

    function shell_CND($rootScope, common, config, datacontext, sectionMenu) {
        var $location = common.$location;

        var vm = this;
        var logError = common.logger.getLogFn(controllerId, 'logError');
        var logSuccess = common.logger.getLogFn(controllerId, 'success');
        var events = config.events;
        vm.busyMessage = 'Please wait ...';
        vm.isBusy = true;
        vm.spinnerOptions = {
            radius: 40,
            lines: 7,
            length: 0,
            width: 30,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#F58A00'
        };
        vm.oggi = new Date();
        vm.help_toggle = help_toggle;
        vm.help_select = help_select;
        vm.showPanelHelp = true;
        
		//Area Selezionata
        vm.datacontext = datacontext;
        vm.getSection = sectionMenu.getSection;
        vm.getLnkPDFBando = sectionMenu.getLnkPDFBando;
        vm.getLnkPDFManuale = sectionMenu.getLnkPDFManuale;
        vm.getLnkOfficialSite = sectionMenu.getLnkOfficialSite;
        vm.urlLogoHeader = sectionMenu.getUrlLogoHeader;
        vm.showInfoMsg = sectionMenu.getInfoMsg;
        vm.getProgettoUID = sectionMenu.getProjectUId;
        vm.tipoCandidatura = sectionMenu.getTipoCandidatura;
        vm.rec_email = '';
        vm.rec_codiceFiscale = '';
        vm.labelCF = sectionMenu.getLabelCF;
        vm.sending = false;
        
        vm.sendLnkAccesso = sendLnkAccesso;

        function help_toggle() {
            vm.panelHelp = 'help_home';
            return vm.showPanelHelp = !vm.showPanelHelp;
        }

        function help_select(panel) {
            console.info('help_select', panel)
            return vm.panelHelp = panel;
        }

        function getUrl(url)
        {
            var n = url.indexOf("#");
            if(n != -1)
            {
                url = url.substring(0, n);
            }
            
            var n = url.lastIndexOf("/");
            if (n != -1) {
                url = url.substring(n);
            }

            
            return url;
        }

        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    var url = $location.absUrl();
                    url = getUrl(url);

                    if (url == "/Accreditamento") {
                        $location.url("/CNDAccreditamento");
                    }
                    else if (url == "/DomandaAdesione") {
                        $location.url("/CNDDomanda");
                    }
                    else if (url == "/CV") {
                        $location.url("/CNDCV");
                    }
											/*
                    else if (url == "/Ruolo_User") {
                        $location.url("/");
                    }
										*/
                });
        }

        function sendLnkAccesso() {
            if (vm.sending == true) return;

            if (vm.rec_email == '' || vm.rec_codiceFiscale == '')
                return logError('E\' necessario compilare tutti i campi');

            var tmpEmail = vm.rec_email;
            vm.sending = true;
            return datacontext.cndProgetto_sendLnkAccesso(vm.getProgettoUID(), vm.rec_email, vm.rec_codiceFiscale, vm.tipoCandidatura()).then(function (data) {
                vm.sending = false;
                if (!data) {
                    return logError('Dati inseriti non validi oppure la domanda non esiste');
                }

                vm.rec_email = '';
                vm.rec_codiceFiscale = '';                
                return logSuccess('Dati inviati all\'indirizzo email: ' + tmpEmail);
            });
        }

        function toggleSpinner(on) { vm.isBusy = on; }

        $rootScope.$on('$routeChangeStart',
            function (event, next, current) { toggleSpinner(true); }
        );

        $rootScope.$on(events.controllerActivateSuccess,
            function (event, data) { toggleSpinner(false); }
        );

        $rootScope.$on(events.spinnerToggle,
            function (event, data) { toggleSpinner(data.show); }
        );

    };
})();